"use client";

import { ThemeProvider } from "@bpipartners/webui";
import { getTheme } from "@quales/utils/theme";
import React from "react";
import { LicenseInfo } from "@bpipartners/webui";
import { SnackbarProvider } from "notistack";
import { ErrorBoundary } from "react-error-boundary";
import { FallbackErrorComponent } from "../../ui/error-component/FallbackErrorComponent";

LicenseInfo.setLicenseKey(
  "142fd24118ec34cc41923c9b61fac59dTz0xMDIwMTAsRT0xNzYzNTc2Mzg1MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj0yMDIyLEtWPTI="
);

export const ClientProviders = ({ children }: { children?: any }) => (
  <ErrorBoundary FallbackComponent={FallbackErrorComponent}>
    <ThemeProvider theme={getTheme()}>
      <SnackbarProvider
        autoHideDuration={3000}
        maxSnack={3}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {children}
      </SnackbarProvider>
    </ThemeProvider>
  </ErrorBoundary>
);
